/**
 * Lenis smooth scroll wrapper.
 *
 * Davranış:
 *  - prefers-reduced-motion aktifse hiç başlatma
 *  - lerp 0.1 (CLAUDE.md §2 motion principles)
 *  - window.akdkLenis global'i hero hover'da pause/resume için
 */

import Lenis from 'lenis';

export function initSmoothScroll() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return null;

  const lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
  });

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);

  window.akdkLenis = lenis;
  return lenis;
}
